// DevHub CUSTOM — i18n "feedback" namespace (toast + confirm dialog chrome only).
// The default action labels reuse commonMessages.actions; only chrome/aria live here.
// See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const feedbackMessages = createTranslationRef({
  id: 'devhub.feedback',
  messages: {
    notifications: 'Notifications',
    dismiss: 'Dismiss',
    dismissDialog: 'Dismiss dialog',
  },
  translations: {
    de: () => import('./de/feedback'),
  },
});
